import { useSelector } from "react-redux";
import { extractValue } from "./utils";

export const useClientNumberOfDependents = () => {
  const { clientData } = useSelector((state) => state.Client);

  return extractValue(clientData, "numberOfDependents");
};